module.exports = __webpack_public_path__ + "img/92.08f27cb1.jpg";